import { VIP_NUM, VIP_PASSPORT_ID } from '@/constant';

const CEO_DEPARTMENT_LABEL = '대표이사';

/** 대표 계정은 직위가 공백으로 내려와, 비었거나 '임원' 인 팀명 자리를 대신 씀 */
const isReplaceableDepartment = (departmentName?: string | null) => {
  const trimmed = departmentName?.trim() ?? '';
  return trimmed === '' || trimmed === '임원';
};

type CeoIdentity = {
  passportId?: string | null;
  employeeNumber?: string | null;
  departmentName?: string | null;
};

/**
 * 팀명 '임원' 은 다른 임원도 해당돼 식별자와 AND 로 묶음.
 * 이름 비교 금지 — 팀명이 '임원' 인 동명이인 레코드가 실재.
 * 타 법인 대표는 직위에 '대표이사' 가 이미 실려 대상 아님(중복 표기).
 */
const isCeo = ({ passportId, employeeNumber, departmentName }: CeoIdentity) =>
  (passportId === VIP_PASSPORT_ID || employeeNumber === VIP_NUM) &&
  isReplaceableDepartment(departmentName);

/**
 * 팀명 자리 값만 치환. 본부명 조립은 호출부가 그대로 유지 → '본부 · 대표이사'.
 * 비대표는 받은 값 그대로 반환 — '' 로 바꾸면 템플릿 리터럴 출력이 달라짐.
 */
export const resolveDepartmentName = <T extends string | null | undefined>(
  identity: CeoIdentity,
  departmentName: T,
): T | string => (isCeo(identity) ? CEO_DEPARTMENT_LABEL : departmentName);
